/**
 * The case's hypotheses with their latest assessment, as the Case summary's narrative header
 * lists them (PRD-0075 R-E5), read live from the case.
 */
import { useTranslation } from 'react-i18next'
import {
  HypothesesDigestView,
  type HypothesisDigestItem,
} from '@/components/analytic-hypotheses/HypothesesDigestView'
import { formatDate } from '@/utils/date'
import { hypothesisPath } from './paths'
import { useAnalyticHypotheses } from './queries'

export function HypothesesDigest({ caseId }: { caseId: string }) {
  const { i18n } = useTranslation()
  const { data, isError } = useAnalyticHypotheses(caseId)
  if (isError) return null
  const items: HypothesisDigestItem[] | null =
    data?.hypotheses.map(hypothesis => ({
      key: hypothesis.id,
      title: hypothesis.title,
      verdict: hypothesis.latest?.verdict ?? null,
      confidence: hypothesis.latest?.confidence ?? null,
      assessedAt: hypothesis.latest
        ? formatDate(hypothesis.latest.created_at, i18n.language)
        : null,
      href: hypothesisPath(caseId, hypothesis.id),
    })) ?? null
  return <HypothesesDigestView items={items} />
}
